import { render, staticRenderFns } from "./price-serve-edit.vue?vue&type=template&id=7a976db8&scoped=true&"
import script from "./price-serve-edit.vue?vue&type=script&lang=js&"
export * from "./price-serve-edit.vue?vue&type=script&lang=js&"
import style0 from "./price-serve-edit.vue?vue&type=style&index=0&id=7a976db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a976db8",
  null
  
)

export default component.exports